import { createContext } from "react";

const UserContext = createContext({
  usuario: {},
  setUsuario: () => {}
});

export default UserContext;
